import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4311100e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "proposal-list" }
const _hoisted_2 = { class: "proposal-list__header" }
const _hoisted_3 = { class: "proposal-list__header__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "proposal-list__header__types" }, null, -1))
const _hoisted_5 = { class: "proposal-list__header__menu" }
const _hoisted_6 = { class: "proposal-list__header__menu__search w-3/6" }
const _hoisted_7 = { class: "proposal-list__header__menu__buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-filter" }, null, -1))
const _hoisted_10 = { class: "proposal-list__content" }
const _hoisted_11 = {
  key: 1,
  class: "bg-white rounded p-5 text-center"
}
const _hoisted_12 = {
  key: 2,
  class: "proposal-list__content__table w-full"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "proposal-list__content__table__header proposal-list__content__table__header--expand" }, null, -1))
const _hoisted_14 = { class: "proposal-list__content__table__header proposal-list__content__table__header--client" }
const _hoisted_15 = { class: "proposal-list__content__table__header proposal-list__content__table__header--number" }
const _hoisted_16 = { class: "proposal-list__content__table__header proposal-list__content__table__header--status" }
const _hoisted_17 = { class: "proposal-list__content__table__header proposal-list__content__table__header--created-by" }
const _hoisted_18 = { class: "proposal-list__content__table__header proposal-list__content__table__header--requested-by" }
const _hoisted_19 = { class: "proposal-list__content__table__header proposal-list__content__table__header--created" }
const _hoisted_20 = { class: "proposal-list__content__table__header proposal-list__content__table__header--sent" }
const _hoisted_21 = { class: "proposal-list__content__table__header proposal-list__content__table__header--approved" }
const _hoisted_22 = { class: "proposal-list__content__table__header proposal-list__content__table__header--rejected" }
const _hoisted_23 = { class: "proposal-list__content__table__header proposal-list__content__table__header--valid-from" }
const _hoisted_24 = { class: "proposal-list__content__table__header proposal-list__content__table__header--valid-till" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "proposal-list__content__table__header proposal-list__content__table__header--actions" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input = _resolveComponent("search-input")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_proposal_row = _resolveComponent("proposal-row")!
  const _component_proposals_list_filters = _resolveComponent("proposals-list-filters")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('proposal.list.header.title')), 1),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_search_input, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            "debounce-time": 0
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: {name: 'proposal.form.select_client'} }, {
            default: _withCtx(() => [
              _createVNode(_component_outline_button, null, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.list.header.menu.add')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_outline_button, {
            type: "outline",
            class: "ml-4",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilters = true))
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('general.filter')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.isProposalsProcessing)
        ? (_openBlock(), _createBlock(_component_content_loader, {
            key: 0,
            label: "general.loading"
          }))
        : _createCommentVNode("", true),
      (!_ctx.filteredProposals.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " There are no proposals "))
        : _createCommentVNode("", true),
      (_ctx.filteredProposals.length)
        ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('proposal.list.content.table.header.client_name')) + " ", 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('proposal.list.content.table.header.proposal_number')) + " ", 1),
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('proposal.list.content.table.header.status')) + " ", 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('proposal.list.content.table.header.created_by')), 1),
              _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('proposal.list.content.table.header.requested_by')), 1),
              _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('proposal.list.content.table.header.created_at')) + " ", 1),
              _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('proposal.list.content.table.header.sent_at')) + " ", 1),
              _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('proposal.list.content.table.header.approved_at')) + " ", 1),
              _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('proposal.list.content.table.header.rejected_at')) + " ", 1),
              _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('proposal.list.content.table.header.valid_from')) + " ", 1),
              _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('proposal.list.content.table.header.valid_till')) + " ", 1),
              _hoisted_25
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProposals, (proposal) => {
              return (_openBlock(), _createBlock(_component_proposal_row, {
                key: proposal.id,
                proposal: proposal
              }, null, 8, ["proposal"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_proposals_list_filters, {
      "show-filters": _ctx.showFilters,
      "onUpdate:showFilters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showFilters) = $event)),
      filters: _ctx.filters,
      onFiltersChange: _ctx.handleFiltersChange
    }, null, 8, ["show-filters", "filters", "onFiltersChange"])
  ]))
}